import React from 'react';
import './Gifting_step_3.css';

import {Helmet} from "react-helmet";
import MasterButton from '../../../general_components/MasterButton/MasterButton.js';

import phones from '../../../../utils/phones.js'; 

class Gifting_step_3 extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeAndSelectEmail = this.handleChangeAndSelectEmail.bind(this);
        this.handleChangeAndSelectPhone = this.handleChangeAndSelectPhone.bind(this);
        this.handlePaste                = this.handlePaste.bind(this);
    }

    handleChangeAndSelectPhone(event, id) {
        document.getElementById(id).checked = true;
        this.props.handlePhoneChange(event);
        this.props.updateChannel(id);
    }

    handleChangeAndSelectEmail(event, id) {
        document.getElementById(id).checked = true;
        this.props.handleChange(event);
        this.props.updateChannel(id);
    }

    // Handle paste event
    handlePaste(e, id){
        
        e.preventDefault(); // Prevent the default paste behavior
        
        const pastedData = e.clipboardData.getData('Text');
        const formattedNumber = phones.from_copy_to_gg(pastedData);

        // activate the phone as selected channel
        document.getElementById(id).checked = true;
        this.props.updateChannel(id);
        this.props.handlePastePhone(e.target.name, formattedNumber);
    };

    /** Child the gift is for — prefilled from the invite URL, editable for nicknames! */
    renderGiftFor() {
        const errors = this.props.field_errors || {};
        const label = this.props.prefilled_gift_for ? 'Gift for:' : 'Who is the gift for?';

        return (
            <div>
                <p className='form_label'>{label}</p>
                <input
                    type='text'
                    id='gift_for_child_name'
                    onChange={this.props.handleChange}
                    name='Gift_for'
                    placeholder='Child name'
                    value={this.props.Gift_for}
                    maxLength='50'
                    autoComplete='on'
                    />
                {errors.Gift_for ? <p className='tiny_text gifting_field_error'>{errors.Gift_for}</p> : null}
            </div>
        );
    }

    /** Sender name + guest receipt email. */
    renderFromFields() {
        const errors = this.props.field_errors || {};

        return (
            <div>
                <p className='form_label'>Who is it from?</p>
                <input
                    type='text'
                    id='gift_from'
                    onChange={this.props.handleChange}
                    name='from'
                    placeholder='Your name'
                    value={this.props.from}
                    maxLength='50'
                    autoComplete='on'
                    />
                {errors.from ? <p className='tiny_text gifting_field_error'>{errors.from}</p> : null}

                {this.props.guest ? (
                    <div>
                        <p className='form_label'>Your email:</p>
                        <input
                            type='text'
                            id='sender_email'
                            onChange={this.props.handleChange}
                            name='sender_email'
                            placeholder='YourEmail@email.com'
                            value={this.props.sender_email}
                            autoComplete='on'
                            />
                        <p className='tiny_text send_to_helper'>Needed so we can send you a receipt.</p>
                    </div>
                ) : null}
            </div>
        );
    }

    /** Who gets the gift message — known from the registry, or typed on organic. */
    renderDeliveryFields(isRegistry) {
        if (isRegistry) {
            return (
                <div>
                    <p>The gift will be sent to {this.props.receiver} by text message to the number ending in:</p>
                    <p className='small_text'>(XXX) XXX-{this.props.receiver_number}</p>
                </div>
            );
        }

        return (
            <div>
                <p className='form_label'>Send to:</p>
                <input
                    type='text'
                    id='send_to_guardian'
                    name='Send_to'
                    placeholder='Alex'
                    onChange={this.props.handleChange}
                    value={this.props.Send_to}
                    />
                <p className='tiny_text send_to_helper'>Person that should get the text or email notification about the gift.</p>

                <input
                    type='radio'
                    id='channel_text'
                    name='channel'
                    value='text_message'
                    onChange={this.props.handleChange}
                    checked={this.props.channel === 'text_message'}/>
                <p className='form_radio_label'>Text message:</p>

                <input
                    type='text'
                    id='text_message_number_input'
                    name='send_to_number'
                    placeholder='555-555-5555'
                    maxLength='12'
                    onChange={(event) => {this.handleChangeAndSelectPhone(event, 'channel_text')}}
                    onPaste={(event) => {this.handlePaste(event, 'channel_text')}}
                    value={this.props.send_to_number}
                    />

                <input
                    type='radio'
                    id='channel_email'
                    name='channel'
                    value='email'
                    onChange={this.props.handleChange}
                    checked={this.props.channel === 'email'}/>
                <p className='form_radio_label'>Email:</p>

                <input
                    type='text'
                    id='email_input'
                    name='send_to_email'
                    placeholder='Example@email.com'
                    onChange={(event) => {this.handleChangeAndSelectEmail(event, 'channel_email')}}
                    value={this.props.send_to_email}
                    />
            </div>
        );
    }

    render () {
        const showAt = this.props.showAtStep != null ? this.props.showAtStep : 3;
        if (this.props.currentStep !== showAt) {
            return null;
        }

        const isRegistry = !!(this.props.receiver_number && this.props.receiver);

        return (
           <div>
                <Helmet>
                    <title>{`Give a Monetary Gift | To & From | Greatest Gift`}</title>
                </Helmet>
                <h2>To &amp; From</h2>

                <form>
                    {this.renderGiftFor()}
                    {this.renderDeliveryFields(isRegistry)}

                    <div className='section_with_top_line to_from_from_section'>
                        {this.renderFromFields()}
                    </div>
                </form>

                <MasterButton
                    buttonText={this.props.buttonText}
                    handleButtonClick={this.props.handleButtonClick}
                    notSticky={true}
                />
           </div>
        );
    }
}

export default Gifting_step_3;
